export const OpsEstateRoute = {
  DASHBOARD: { name: 'ops-dashboard', path: 'dashboard' },
  DETAILS: { name: 'ops-details', path: 'estate/details/:id' },
  SETTLEMENT: { name: 'ops-settlement', path: 'settlement' },
  SETTLEMENT_CANADA: {
    name: 'ops-settlement-canada',
    path: 'canada'
  },
  SETTLEMENT_US: {
    name: 'ops-settlement-us',
    path: 'us'
  },
  SETTLEMENT_INACTIVE: {
    name: 'ops-settlement-inactive',
    path: 'inactive'
  },
  PLANNING: { name: 'ops-planning', path: 'planning' },
  PLANNING_CANADA: {
    name: 'ops-planning-canada',
    path: 'canada'
  },
  PLANNING_US: {
    name: 'ops-planning-us',
    path: 'us'
  },
  PLANNING_INACTIVE: {
    name: 'ops-planning-inactive',
    path: 'inactive'
  }
};
